import ApiService from '@ecocoach/domain-store-modules/src/services/api.service'

export default {
  async initiateAccountDeletion(): Promise<void> {
    await ApiService.post(`${ApiService.backendEnvironmentConfiguration().userSettingsApi}/Accounts/initiateAccountDeletion`, {})
  },
}
